// Seeded pseudo-random + simple value-noise utilities used for procedural
// vinyl finishes (splatter / marble). Deterministic given the same seed so
// the same disc settings always render identically.

export function makeSeededRandom(seed) {
  let s = seed % 2147483647;
  if (s <= 0) s += 2147483646;
  return function next() {
    s = (s * 16807) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

// Cheap 2D value-noise: hash lattice corners with the seeded RNG and
// bilinearly interpolate. Good enough for organic marble veins / splatter
// jitter without pulling in a full Perlin implementation.
export function valueNoise2D(seed) {
  const cache = new Map();
  function hash(ix, iy) {
    const key = ix * 73856093 ^ iy * 19349663 ^ seed * 83492791;
    const rnd = makeSeededRandom(Math.abs(key) || 1)();
    return rnd;
  }
  function smooth(t) {
    return t * t * (3 - 2 * t);
  }
  return function noise(x, y) {
    const ix = Math.floor(x);
    const iy = Math.floor(y);
    const fx = smooth(x - ix);
    const fy = smooth(y - iy);
    const v00 = hash(ix, iy);
    const v10 = hash(ix + 1, iy);
    const v01 = hash(ix, iy + 1);
    const v11 = hash(ix + 1, iy + 1);
    const a = v00 + (v10 - v00) * fx;
    const b = v01 + (v11 - v01) * fx;
    return a + (b - a) * fy;
  };
}
